import React from 'react'
// Node modules
import styled from 'styled-components'
// Layouts
import WelcomePageTitle from './records/WelcomePageTitle'
import WelcomePageNotification from './WelcomePageNotification'
import { useNavigate } from 'react-router'

const WelcomePageNotificationsContainer = styled.div`
`

export default function WelcomePageNotifications({ notifications, babysittingModes }) {
  const navigate = useNavigate()

  const openNotificationDetail = (notifId) => {
    navigate(`/notifications/${ notifId }`)
  }

  return (
    <WelcomePageNotificationsContainer>

      { notifications && notifications.length > 0 &&
      <WelcomePageTitle margin="40px 0px 15px 20px" label="Mes notifications"/> }

      { notifications.map((notification, index) => {

        return (
          <WelcomePageNotification
            key={ notification._id }
            notification={ notification }
            babysittingModes={ babysittingModes }
            action={ () => openNotificationDetail(notification._id) }/>
        )

      }) }

    </WelcomePageNotificationsContainer>
  )

}
